export default __webpack_public_path__ + "static/media/big-logo.95cad1f3.svg";